// extracted by mini-css-extract-plugin
module.exports = {"linkLists":"LinkLists_linkLists__UDhUm","column":"LinkLists_column__7cerz","moreNews":"LinkLists_moreNews__vq58P"};